import { useLocation } from "react-router-dom";

export const useKanbanMilestoneTab = () => {

    const location = useLocation()
    const [, , , , , , , ,tab] = location.pathname.split("/");
    return tab
}
